import React from 'react'; // eslint-disable-line
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CustomInput from './CustomInput';

export default class EditableLabel extends React.Component {
    constructor(props) {
        super(props);
        this.myInp = React.createRef();
        this.focusTextInput = this.focusTextInput.bind(this);
    }

    focusTextInput() {
        // Explicitly focus the text input using the raw DOM API
        // Note: we're accessing "current" to get the DOM node
        this.myInp.current.focus();
    }

    render() {
        return (
            <div
                className="module-name-wrap editable-label"
                onFocus={() => {
                    this.props.switchState(true);
                }}
                onBlur={() => {
                    this.props.switchState(false);
                }}
            >
                <h3>{this.props.value}</h3>
                { /* using a hidden h3 to measure the width for where the
            pencil svg should go is somewhat ridiculous. */}
                <CustomInput
                    id={this.props.id}
                    type="text"
                    value={this.props.value}
                    onBlur={(e) => this.props.onChange(e)}
                    className="edit-module-name"
                    placeholder={this.props.placeholder}
                    maxLength={this.props.maxChars}
                    autoFocus={false}
                    onReturnDown={(e) => this.props.onChange(e)}
                    disabled={this.props.disabled}
                    refInput={this.myInp}
                    menuTitle={this.props.menuTitle}
                />
                <FontAwesomeIcon icon={['fas', 'pencil']} color="#616B7D" onClick={this.focusTextInput} style={{ cursor: 'pointer' }} />
            </div>
        );
    }
}
